import Loadable from 'components/Loadable';

export default {
  exact: true,
  auth: true,
  path: '/dashboard',
  component: Loadable({
    loader: () => import('./dashboard'),
  }),
};



// WEBPACK FOOTER //
// ./src/pages/back/dashboard/index.js